import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieListItemProps {
  movie: Movie;
}

export default function MovieListItem({ movie }: MovieListItemProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex gap-4 bg-background-100 border border-background-200 rounded-lg overflow-hidden p-3 hover:border-accent-400 transition-colors cursor-pointer"
    >
      <div className="relative w-28 sm:w-36 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-primary-900">
        <img
          src={movie.cover}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 诱人的女员工hd影视专区`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {movie.rating > 0 && (
          <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-bold">
            {movie.rating.toFixed(1)}
          </span>
        )}
      </div>
      <div className="flex-1 min-w-0 py-1">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-heading font-bold text-foreground-950 text-base group-hover:text-accent-600 transition-colors">
            {movie.title}
          </h3>
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-xs">
            {movie.type === 'movie' ? '电影' : '剧集'}
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-2 text-xs text-foreground-500">
          {movie.genres.map((g) => (
            <span key={g} className="px-1.5 py-0.5 rounded bg-background-200 text-foreground-600">
              {g}
            </span>
          ))}
          <span>{movie.year}</span>
          <span>·</span>
          <span>{movie.region}</span>
        </div>
        <p className="mt-2 text-xs sm:text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {movie.synopsis}
        </p>
        <p className="mt-2 text-xs text-foreground-500 truncate">
          导演：{movie.director} · 主演：{movie.cast.join('、')}
        </p>
      </div>
    </Link>
  );
}